import * as React from 'react';
import { useState } from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  title?: string;
  titleInside?: boolean;
  wrapperClasses?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, wrapperClasses, ...props }, ref) => {
    const { error, title, titleInside, ...restProps } = props;
    const [focused, setFocused] = useState(false);

    return (
      <div className={cn('flex flex-col relative', wrapperClasses || '')}>
        {title && !titleInside && (
          <div
            className={cn('mb-2 font-medium text-sm', {
              'text-grey-2 mb-0 py-2 px-4 w-full bg-white': titleInside,
            })}
          >
            {title}
          </div>
        )}

        <div
          className={cn(
            'relative flex flex-col  flex-grow rounded-xl border',
            'border-light-grey overflow-hidden pb-1 bg-background hover:shadow-outline',
            { 'shadow-outline': focused }
          )}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          <textarea
            className={cn(
              'flex min-h-[66px] w-full px-4 pb-2 pt-[34px] ring-offset-background placeholder:text-[12px]',
              'placeholder:text-mid-gray focus-visible:outline-none',
              'disabled:cursor-not-allowed disabled:opacity-50 peer',
              className
            )}
            placeholder={' '}
            ref={ref}
            {...restProps}
          />

          {title && titleInside && (
            <div
              className={cn(
                'mb-0 py-2 px-4 w-full font-medium text-base pointer-events-none',
                'absolute top-[33px] transform -translate-y-1/2 left-0 z-10 text-grey-2',
                'flex items-center bg-white'
              )}
              data-title
            >
              {title}
            </div>
          )}

          {error && (
            <p className='h-6 px-2 py-1 text-[10px] text-orange'>{error}</p>
          )}
        </div>
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
